<template>
  <option ref="option" :value="value">
    <slot></slot>
  </option>
</template>

<script>
export default {
  props: {
    value: {}
  },
  mounted() {
    this.$refs.option.innerText = this.$refs.option.innerHTML;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OptionHtml.vue